// Copyright (c) Microsoft. All rights reserved.

import { useMsal } from '@azure/msal-react';
import { Body1, Button, Image, Title3 } from '@fluentui/react-components';
import React from 'react';
import signInLogo from '../../ms-symbollockup_signin_light.svg';
import { useSharedClasses } from '../../styles';
import { getErrorDetails } from '../utils/TextUtils';

export const Login: React.FC = () => {
    const { instance } = useMsal();
    const classes = useSharedClasses();

    return (
        <div className={classes.informativeView}>
            <Title3>Login</Title3>
            <Body1>
                {
                    'ACHTUNG: Die Anwendung ist nicht zur Verarbeitung personenbezogener Daten freigegeben. Bitte keine personenbezogenen Daten von Dritten (Mitarbeiter, Kunden, Auftraggebern, Außenstehenden,…) eingeben.'
                }
            </Body1>

            <Button
                style={{ padding: 0 }}
                appearance="transparent"
                onClick={() => {
                    instance.loginRedirect().catch((e: unknown) => {
                        alert(`Error signing in: ${getErrorDetails(e)}`);
                    });
                }}
                data-testid="signinButton"
            >
                <Image src={signInLogo} />
            </Button>
            <a href="https://www.stroeer-x.de/impressum/" target="_blank" rel="noreferrer">
                Impressum der Ströer X Group GmbH
            </a>
            {/* Ströer X Logo */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 245.82" style={{ height: '10%', width: '25%' }}>
                <a href="https://www.stroeer-x.de/" target="_blank" rel="noreferrer">
                    <path
                        d="M660.28 92.89a39.41 39.41 0 0117.8-4.21c17.5-.33 31.72 10 37.85 26.17 1.34 3 3.23 9.08 3.23 18 0 25-15.43 36.69-23.9 40.6-3.33 1.66-8.84 3.57-17.48 3.57-25 0-40.14-20.22-40.45-43.54 0-24.37 14.47-36.36 22.95-40.59M628.27 0l-13.63 35.36-3.21 1.93a109.82 109.82 0 00-46.66 67.13 127.94 127.94 0 00-3.36 28.74c0 48.89 26.84 88.21 72.93 104.7a138.34 138.34 0 0046.54 8c66.32 0 114.2-47.29 114.2-113.59a131.92 131.92 0 00-3.36-30.27c-9.14-35.06-34.45-55.51-44.52-62.21l-7.4-4.68L753.3 0h-52.37l-7.79 20.24a130.75 130.75 0 00-15.95-.66h-4.06L680.63 0zm413.9 121.79V81.48h12.25c12.87 0 26.51 2.53 26.51 19.69a21.67 21.67 0 01-3.39 12.11c-5.53 8.3-14.88 8.51-22.81 8.51zm17.21-96.08h-88.79V241.1h71.58v-85.73l43.37 85.73h80.83l-52.5-86.9c7.32-2.66 12.72-4.74 19.22-9.18 9.56-6.87 22.21-20.33 22.21-48.19 0-22.12-8.48-35.1-13.91-42-15.37-20.2-37.74-26.94-62.62-28.48-6.45-.61-12.94-.61-19.39-.61m-620.75 96.05V81.48h12.25c12.87 0 26.5 2.53 26.5 19.69a21.67 21.67 0 01-3.38 12.11c-5.53 8.3-14.88 8.51-22.8 8.51zm17.2-96.08H367V241.1h71.59v-85.73L482 241.1h80.83l-52.5-86.9c7.32-2.66 12.73-4.74 19.22-9.18 9.56-6.87 22.21-20.33 22.21-48.19 0-22.12-8.47-35.1-13.9-42-15.37-20.2-37.74-26.94-62.63-28.48-6.45-.61-12.93-.61-19.39-.61m-269.87-.03v62.28h43.39l-.01 153.11h77.17V87.99h43.7V25.71H185.97zM808.99 241.1h145.64v-57.64h-74.68v-23.87h66.94v-54.85h-66.94v-21.4h72.52V25.71H808.99V241.1zM153.35 29.72c-17-6.66-36.79-11.08-55.12-11.08-32.8 0-65.81 12.57-80.91 43.37A75.26 75.26 0 009.44 96c0 37.91 27.83 50.82 40.68 55.41a268.94 268.94 0 0032 7.38l5 1.07c6.16 1.51 12.15 4.49 12.15 12.08 0 8.25-8.48 15-22.48 15-19.39 0-38.05-12.4-52.86-22.65L0 221c28.59 15 54.69 23.86 87.69 23.86 25.72 0 46.35-5.78 65.49-22.8 22.15-20.32 24.82-42.7 24.82-54.5 0-14.57-3.88-43.1-39.5-57-9.24-3.39-25.22-7.07-34.77-9.22l-5.21-1.06C92.48 98.89 86 96.08 86 88.52c0-8.39 7.47-12.55 19.66-12.86 17.2 0 31.41 8 45.38 16.27l21.86-53.38c-4.82-2.31-11.29-5.59-19.55-8.83m1083.6-4.05h99.82l82.29 107.92-82.29 107.92h-99.82l80.26-107.92-80.26-107.92zm193.55 122.4l-50.79 66.61 20.46 26.83H1500l-69.5-93.44zm0-28.96l69.5-93.44h-99.83l-20.46 26.84 50.79 66.6z"
                        fill="rgba(8, 32, 74, 1)"
                    ></path>
                </a>
            </svg>
        </div>
    );
};
